import { type ReactNode } from 'react';

import { Box } from '@betterment/samba-react';

interface GradientIconBadgeProps {
  children?: ReactNode;
}

const GradientIconBadge = ({ children }: GradientIconBadgeProps) => (
  <Box
    css={{
      alignItems: 'center',
      backgroundImage: '[linear-gradient(306deg,#3783FC,#9EC9FF)]',
      borderRadius: 'medium',
      boxShadow: '1px 1px 0 #042D70, 4px 4px 0 rgba(0,11,80,0.25)',
      display: 'inline-flex',
      height: 'size.400',
      justifyContent: 'center',
      width: 'size.400',
    }}
  >
    {children}
  </Box>
);

GradientIconBadge.displayName = 'GradientIconBadge';

export { GradientIconBadge };
